import React, { Fragment, memo } from "react";
import { Box } from "@mui/material";

// *Import Components
import Header from "./Header";
import SideNav from "./SideNav";

function Layout({ children }) {
  return (
    <Fragment>
      {/* ========== Header ========== */}

      <Header />

      <Box sx={{ display: "flex" }}>
        {/* ========== SideNav ========== */}
        <Box>
          <SideNav />
        </Box>

        <Box sx={{ mt: "100px", mx: 2, flexGrow: 1 }}>{children}</Box>
      </Box>
    </Fragment>
  );
}

export default memo(Layout);
